import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

type WrapperBannerProps = {
  backgroundColor?: string;
  borderColor?: string;
};

export const WrapperBanner = styled("div")(
  ({
    backgroundColor = colors.brandBlue50,
    borderColor = colors.brandBlue200,
  }: WrapperBannerProps) => ({
    marginTop: 24,
    marginBottom: 24,
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    padding: 12,

    border: `1px solid ${borderColor}`,
    borderRadius: 8,
    backgroundColor,
  })
);

type BannerTextProps = {
  textColor?: string;
};

export const BannerText = styled("span")(
  ({ textColor = colors.brandBlue700 }: BannerTextProps) => ({
    fontFamily: "Manrope",
    fontWeight: 400,
    color: textColor,
    fontSize: 14,
    lineHeight: "20px",
    letterSpacing: 0.25,
    textAlign: "justify",
  })
);
